import * as React from "react";
import { cn } from "@/lib/utils";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/v2/ui/primitives/card";

export interface Breadcrumb {
  label: string;
  href?: string;
}

export interface DashboardLayoutProps {
  children: React.ReactNode;
  title: string;
  breadcrumbs?: Breadcrumb[];
  actions?: React.ReactNode;
  className?: string;
}

const DashboardLayout = React.forwardRef<HTMLDivElement, DashboardLayoutProps>(
  ({ children, title, breadcrumbs, actions, className }, ref) => {
    return (
      <div ref={ref} className={cn("tw-space-y-6", className)}>
        <div className="tw-flex tw-flex-col tw-gap-4 md:tw-flex-row md:tw-items-center md:tw-justify-between">
          <div className="tw-space-y-2">
            {breadcrumbs && breadcrumbs.length > 0 && (
              <nav className="tw-flex tw-items-center tw-space-x-2 tw-text-sm tw-text-muted-foreground">
                {breadcrumbs.map((crumb, index) => (
                  <React.Fragment key={crumb.label}>
                    {index > 0 && (
                      <span className="tw-text-muted-foreground">/</span>
                    )}
                    {crumb.href ? (
                      <a
                        href={crumb.href}
                        className="tw-transition-colors hover:tw-text-foreground"
                      >
                        {crumb.label}
                      </a>
                    ) : (
                      <span className="tw-font-medium tw-text-foreground">
                        {crumb.label}
                      </span>
                    )}
                  </React.Fragment>
                ))}
              </nav>
            )}

            <h1 className="tw-text-3xl tw-font-bold tw-tracking-tight">
              {title}
            </h1>
          </div>

          {actions && (
            <div className="tw-flex tw-items-center tw-gap-2">{actions}</div>
          )}
        </div>

        <Card>
          <CardContent className="tw-p-6">{children}</CardContent>
        </Card>
      </div>
    );
  }
);

DashboardLayout.displayName = "DashboardLayout";

export { DashboardLayout };
